import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { debounceTime, Subject } from 'rxjs';
import { PaisDto } from '../../../dto/expediente/pais.dto';
import { DepartmentoDto } from '../../../dto/expediente/departmento.dto';
import { ListasService } from '../../../services/listas.service';
import { MunicipioDto } from '../../../dto/expediente/municipio.dto';
import { TipoPersonaDto } from '../../../dto/expediente/tipo-persona-dto.dto';
import { Constants } from '../../../constants/constants';
import { TipoDocumentoDto } from '../../../dto/expediente/tipo-documento.dto';
import { dominioValidador } from '../../util/validadores/validador-dominio';
import { PersonaLoginDTO } from '../../../dto/util/persona.dto';
import { TranslateService } from '@ngx-translate/core';
import { TextTransformService } from '../../util/text-transform/text-transform.service';
import { ConfigurarCuentasService } from '../../configuracion-cuenta/services/configurar-cuentas.service';

@Component({
  selector: 'app-persona-abogado',
  templateUrl: './persona-abogado.component.html',
  styleUrl: './persona-abogado.component.scss'
})
export class PersonaAbogadoComponent implements OnInit, OnChanges {

  abogadoForm: FormGroup = new FormGroup({});

  // Objeto para almacenar el estado de autocompletado de los campos
  autocompletedFields: { [key: string]: boolean } = {};

  private formChanges = new Subject<void>();
  constants = Constants;
  validationMessage = '';
  validationMessagePattern = '';

  // Multilenguaje
  personaText: any = {};
  comunText: any = {};

  constructor(
    private readonly fb: FormBuilder,
    private readonly listService: ListasService,
    private readonly translate: TranslateService,
    private readonly textTransformService: TextTransformService,
    private readonly _cuentaService: ConfigurarCuentasService
  ) {
    this.buildForm();
  }
  selectedOption = '';
  departments: DepartmentoDto[] = [];
  municipalities: MunicipioDto[] = [];
  hideDepartment = false;
  hideMunicipality = false;

  @Input() countries: PaisDto[] = [];
  @Input() documentTypeListApoderado: TipoDocumentoDto[] = [];
  @Output() formData = new EventEmitter<{ valid: boolean; data: any }>();
  @Input() dataLogin!: PersonaLoginDTO | undefined;
  @Input() isDimar = true;
  @Input() autocompleted = true;
  @Input() values: any;
  @Input() isApoderado = true;
  @Input() aditionalText = '';
  @Input() showAditionalText = false;

  typePerson: string = '';
  buildForm() {
    this.abogadoForm = this.fb.group({
      tipoDePersona: ['1', [Validators.required]],
      email: [
        '',
        [
          Validators.required,
          Validators.pattern(Constants.REGEX_CORREO_ELECTRONICO),
          dominioValidador(),
          Validators.maxLength(100),
        ],
      ],
      primerNombre: [
        '',
        [
          Validators.required,
          Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_PLAIN_TEXT),
          Validators.minLength(2)
        ],
      ],
      segundoNombre: [
        '',
        [Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_PLAIN_TEXT),
        Validators.minLength(2)
        ],
      ],
      primerApellido: [
        '',
        [
          Validators.required,
          Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_PLAIN_TEXT),
          Validators.minLength(2)
        ],
      ],
      segundoApellido: [
        '',
        [Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_PLAIN_TEXT),
        Validators.minLength(2)]
      ],
      tipoDocumento: ['', Validators.required],
      identificacion: [
        {
          value: '',
          disabled: true,
        },
        [Validators.required],
      ],
      pais: ['', [Validators.required]],
      departmento: ['', [Validators.required]],
      municipio: ['', [Validators.required]],
      otroDepartamento: [''],
      otroMunicipio: [''],
      direccion: [
        '',
        [
          Validators.required,
          Validators.pattern(
            Constants.REGEX_ALPHANUMERIC_WITHOUT_SPACES_ADDRESS
          ),
          Validators.maxLength(40),
          Validators.minLength(10),
        ],
      ],
    });
  }

  ngOnInit() {

    this.formChanges.pipe(debounceTime(300)).subscribe(() => {
      this.emitFormData();
    });

    // Detecta cambios en el formulario
    this.abogadoForm.valueChanges.subscribe(() => {
      this.formChanges.next();
      this.checkAutocomplete();
    });
    this.abogadoForm.get('tipoDocumento')?.valueChanges.subscribe(type => {
      this.updateIdentificationValidators(type);
    });
    const user_type = JSON.parse(
      sessionStorage.getItem(Constants.USER_TYPE) ?? '{}');
    this.typePerson = user_type.Nombre;
    if (this.isDimar) {
      setTimeout(() => {
        if (this.dataLogin !== undefined) {
          this.isApoderado = user_type.Nombre === 'Abogado';
          if (this.isApoderado && user_type.Nombre === 'Abogado') {
            this.setValuesApoderado(this.dataLogin);
          }
        }

      }, 1000);
    }

    if (this.values !== undefined) {
      Object.keys(this.values).forEach(key => {

        if (key === 'pais') {
          this.onChangeCountry({ target: { value: this.values[key] } }, true);
        }

        this.abogadoForm?.get(key)?.setValue(this.values[key]);
        this.abogadoForm?.get(key)?.updateValueAndValidity();
      });
    }

    this.translate.stream('tramites').forEach(text => {
      for (const key of Object.keys(text)) {
        this.personaText[key] = text[key];
      }
    });
    this.translate.stream('comun-label').forEach(text => {
      for (const key of Object.keys(text)) {
        this.comunText[key] = text[key];
      }
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['dataLogin'] && changes['dataLogin'].currentValue) {
    }
    const user_type = JSON.parse(
      sessionStorage.getItem(Constants.USER_TYPE) ?? '{}');
    if (this.isDimar) {
      setTimeout(() => {
        if (this.dataLogin !== undefined) {
          this.isApoderado = user_type.Nombre === 'Abogado';
          if (this.isApoderado && user_type.Nombre === 'Abogado') {
            this.setValuesApoderado(this.dataLogin);
          }
        }
        setTimeout(() => {
          this.emitFormData();
        }, 1500);
      }, 1000);
    }

    if (changes['values'] && changes['values'].currentValue) {
      Object.keys(changes['values'].currentValue).forEach(key => {
        if (
          changes['values'].currentValue[key] ===
          changes['values'].previousValue[key]
        ) {
          return;
        }

        if (key === 'pais') {
          if (changes['values'].currentValue[key] != null) {
            this.onChangeCountry(
              { target: { value: changes['values'].currentValue[key] } },
              true
            );
          }
        }

        this.abogadoForm
          ?.get(key)
          ?.setValue(changes['values'].currentValue[key]);
        this.abogadoForm?.get(key)?.updateValueAndValidity();
      });
    }
  }

  emitFormData() {
    this.formData.emit({
      valid: this.abogadoForm.valid,
      data: this.abogadoForm.value
    });
  }

  onChangeCountry(event: any, preload?: boolean) {
    if (event.target.value != '') {
      this.listService
        .getDepartmentList(event.target.value)
        .subscribe(departments => {
          this.departments = departments;
          this.abogadoForm.get('municipio')?.setValue('');
          this.municipalities = [];
          const selectedCountry = this.countries.find(
            country => country.Id === +event.target.value
          );
          if (selectedCountry?.Codigo !== 'CO') {
            this.abogadoForm.get('departmento')?.setValue(this.departments?.[0]?.Id);
            this.abogadoForm.get('departmento')?.clearValidators();
            this.abogadoForm.get('departmento')?.updateValueAndValidity();
            this.onChangeDepartment(null, false, this.departments?.[0]?.Id);
            this.abogadoForm.get('otroDepartamento')?.setValue('');
            this.abogadoForm.get('otroDepartamento')?.setValidators([
              Validators.required,
              Validators.maxLength(30),
              Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_WITH_ACCENTS)
            ]);
            this.abogadoForm.get('otroDepartamento')?.updateValueAndValidity();
            this.abogadoForm.get('otroMunicipio')?.setValue('');
            this.abogadoForm.get('otroMunicipio')?.setValidators([
              Validators.required,
              Validators.maxLength(30),
              Validators.pattern(Constants.REGEX_STRING_WITHOUT_SPACES_WITH_ACCENTS)
            ]);
            this.abogadoForm.get('otroMunicipio')?.updateValueAndValidity();
            // this.onChangeDepartment({
            //   target: { value: this.departments[0]?.Id },
            // });
            this.onChangeDepartment({
              target: { value: '' },
            });
            this.hideDepartment = true;
            this.hideMunicipality = true;
            this.emitFormData();
          } else {
            this.hideDepartment = false;
            this.hideMunicipality = false;
            this.abogadoForm.get('departmento')?.setValue('');
            this.abogadoForm.get('otroDepartamento')?.setValue('');
            this.abogadoForm.get('otroMunicipio')?.setValue('');
            this.abogadoForm.get('municipio')?.setValue('');
            this.abogadoForm.get('departmento')?.setValidators([Validators.required]);
            this.abogadoForm.get('municipio')?.setValidators([Validators.required]);
            this.abogadoForm.get('otroDepartamento')?.clearValidators();
            this.abogadoForm.get('otroMunicipio')?.clearValidators();
            this.abogadoForm.get('departmento')?.updateValueAndValidity();
            this.abogadoForm.get('municipio')?.updateValueAndValidity();
            this.abogadoForm.get('otroDepartamento')?.updateValueAndValidity();
            this.abogadoForm.get('otroMunicipio')?.updateValueAndValidity();
          }
          if (preload) {
            this.abogadoForm?.get('departmento')?.setValue(this.values['departmento']);
            this.abogadoForm.get('otroDepartamento')?.setValue(this.values['otroDepartamento']);
            this.abogadoForm.get('otroMunicipio')?.setValue(this.values['otroMunicipio']);
            if (this.abogadoForm?.get('pais')?.value == 1) {
              this.onChangeDepartment({ target: { value: this.values['departmento'] } }, true);
            }
            this.abogadoForm.get('departmento')?.updateValueAndValidity();
            this.abogadoForm.get('otroDepartamento')?.updateValueAndValidity();
            this.abogadoForm.get('otroMunicipio')?.updateValueAndValidity();
          }
        });
    } else {
      this.abogadoForm.get('departmento')?.setValue('');
      this.abogadoForm.get('municipio')?.setValue('');
      this.abogadoForm.get('otroDepartamento')?.setValue('');
      this.abogadoForm.get('otroMunicipio')?.setValue('');
      this.abogadoForm.get('departmento')?.updateValueAndValidity();
      this.abogadoForm.get('municipio')?.updateValueAndValidity();
      this.abogadoForm.get('otroDepartamento')?.updateValueAndValidity();
      this.abogadoForm.get('otroMunicipio')?.updateValueAndValidity();
    }
  }
  onChangeDepartment(event: any, preload?: boolean, idDepartamento: number | undefined = undefined) {
    if (event?.target?.value != '' || idDepartamento) {
      const departamento =
        event?.target?.value && event?.target?.value != ''
          ? event?.target?.value
          : idDepartamento;
      this.listService
        .getMunicipalityList(departamento)
        .subscribe(municipalities => {
          this.municipalities = municipalities;
          const selectedCountry = this.countries.find(
            country => country.Id === +this.abogadoForm.get('pais')?.value
          );

          if (selectedCountry?.Codigo !== 'CO') {
            /** Se limpia opciones de municipio
             *           this.abogadoForm
              .get('municipio')
              ?.setValue(this.municipalities[0]?.Id);
             *
             */
            this.abogadoForm.get('municipio')?.setValue(this.municipalities?.[0].Id);
            this.abogadoForm.get('municipio')?.updateValueAndValidity();
            this.hideMunicipality = true;
            this.emitFormData();
          } else {
            this.hideMunicipality = false;
            this.abogadoForm.get('municipio')?.setValue('');
            this.abogadoForm.get('municipio')?.updateValueAndValidity();
          }
          if (preload) {
            if (this.abogadoForm.get('departmento')?.value) {
              if (selectedCountry?.Codigo !== 'CO') {
                this.abogadoForm?.get('municipio')?.setValue('');
              } else {
                this.abogadoForm
                  ?.get('municipio')
                  ?.setValue(this.values['municipio']);
              }
            } else {
              this.abogadoForm?.get('municipio')?.setValue('');
            }
            this.abogadoForm.get('municipio')?.updateValueAndValidity();
          }
        });
    } else {
      this.abogadoForm.get('departmento')?.setValue('');
      this.abogadoForm.get('municipio')?.setValue('');
      this.abogadoForm.get('departmento')?.updateValueAndValidity();
      this.abogadoForm.get('municipio')?.updateValueAndValidity();
    }
  }

  updateIdentificationValidators(type: number) {
    const indentificationControl = this.abogadoForm.get('identificacion');
    indentificationControl?.enable();

    if (+this.abogadoForm.get('tipoDePersona')?.value === 1) {
      if (+type === Constants.CEDULA_ID || +type === 5 || +type === 2) {
        indentificationControl?.setValidators([
          Validators.required,
          Validators.minLength(4),
          Validators.maxLength(12),
          Validators.pattern(/^\d+$/), // Solo números
        ]);
        this.validationMessage =
          this.personaText['CC-maxlength'];
        this.validationMessagePattern =
          this.personaText['CC-pattern'];
      } else if (+type === Constants.FOREIGNER_ID) {
        indentificationControl?.setValidators([
          Validators.required,
          Validators.minLength(4),
          Validators.maxLength(8),
          Validators.pattern(/^[a-zA-Z0-9]+$/), // Letras y números
        ]);
        this.validationMessage =
          this.personaText['CE-maxlength'];
        this.validationMessagePattern =
          this.personaText['CE-pattern'];
      }
    } else {
      indentificationControl?.setValidators([
        Validators.required,
        Validators.maxLength(9),
        Validators.pattern(/^\d+$/), // Solo números
      ]);
      this.validationMessage =
        this.personaText['otro-maxlength'];
      this.validationMessagePattern =
        this.personaText['otro-pattern'];
    }

    indentificationControl?.updateValueAndValidity();
  }

  setValuesApoderado(data: PersonaLoginDTO) {
    let tipoDocumento: number = 0;
    switch (data.tipoDocumento) {
      case 'CC':
        tipoDocumento = 1;
        break;
      case 'CE':
        tipoDocumento = 2;
        break;
      case 'Pasaporte':
        tipoDocumento = 4;
        break;
    }
    data = this.textTransformService.transformarAMayusculas(data);
    this.abogadoForm.get('tipoDePersona')?.setValue(1);
    this.abogadoForm.get('tipoDocumento')?.setValue(tipoDocumento);
    this.abogadoForm.get('primerNombre')?.setValue(data.primerNombre);
    this.abogadoForm.get('segundoNombre')?.setValue(data.segundoNombre);
    this.abogadoForm.get('primerApellido')?.setValue(data.primerApellido);
    this.abogadoForm.get('segundoApellido')?.setValue(data.segundoApellido);
    this.updateIdentificationValidators(
      this.abogadoForm.get('tipoDocumento')?.value
    );
    this.setDataComun(data);
  }

  setDataComun(data: PersonaLoginDTO) {
    data = this.textTransformService.transformarAMayusculas(data);

    this.abogadoForm.get('identificacion')?.setValue(data.identificacion);
    this.abogadoForm.get('email')?.setValue(data.correoElectronico);
    data.direccion?.forEach(
      (elemento: {
        Direccion_Notificacion?: string;
        Es_Primaria?: boolean;
        Id?: number;
      }) => {
        if (elemento.Es_Primaria) {
          this.abogadoForm
            .get('direccion')
            ?.setValue(elemento.Direccion_Notificacion);
        }
      }
    );

    if (data.pais) {
      this.getUbicacion(data);
    }
  }

  getUbicacion(data: PersonaLoginDTO) {
    this.abogadoForm.get('pais')?.setValue(data.pais);
    if (data.pais == 1) {
      this.listService.getDepartmentList(data.pais).subscribe(departments => {
        this.departments = departments;
      });
      this.listService
        .getMunicipalityList(data.departamento)
        .subscribe(municipalities => {
          this.municipalities = municipalities;
        });
      setTimeout(() => {
        this.abogadoForm.get('departmento')?.setValue(data.departamento);
        this.abogadoForm.get('municipio')?.setValue(data.municipio);
      }, 1000);
    } else {
      setTimeout(() => {
        this.onChangeCountry({ target: { value: data.pais } }, false);
        this._cuentaService.getDataPersonal(+this.dataLogin!.idUsuario!).subscribe(
          (response: any) => {
            this.abogadoForm.get('otroDepartamento')?.setValue(response.data.Otro_Departamento);
            this.abogadoForm.get('otroMunicipio')?.setValue(response.data.Otro_Municipio);
          }
        );
      }, 400);


    }

  }

  // Método para verificar si los campos están autocompletados
  checkAutocomplete(): void {
    Object.keys(this.abogadoForm.controls).forEach(fieldName => {
      const control = this.abogadoForm.get(fieldName);
      if (control?.value && !control?.touched) {
        this.autocompletedFields[fieldName] = true;
      }
    });
  }

  // Verificar si un campo está marcado como autocompletado
  isAutocompleted(fieldName: string): boolean {
    return this.autocompletedFields[fieldName];
  }

  // Quitar el sombreado cuando el campo está en edición
  onFocus(fieldName: string): void {
    this.autocompletedFields[fieldName] = false;
  }

  marcarTodoComoTocado(): void {
    this.abogadoForm.markAllAsTouched();

  }

  get isButtonEnabled(): boolean {
    return this.abogadoForm.valid;
  }
}
